<div class="loader-wrapper d-flex justify-content-center align-items-center mr-5">
    <div class="loader">
      <div class="ball-pulse">
        <div style="background-color: rgb(63, 106, 216);"></div>
        <div style="background-color: rgb(63, 106, 216);"></div>
        <div style="background-color: rgb(63, 106, 216);"></div>
      </div>
    </div>
  </div>
